import * as AccommodationService from '~/services/AccommodationService';

import { CatalogItemAssociationConfig } from '../types/catalogItem';

export const roomAmenityAssociationConfig: CatalogItemAssociationConfig<
  AccommodationService.AdminAmenity,
  AccommodationService.AdminRoomCatalogAmenity,
  AccommodationService.RoomAmenityAddPayload,
  AccommodationService.RoomAmenityUpdatePayload
> = {
  // Service methods
  listAllItems: async (params) => {
    const response = await AccommodationService.listAmenities({
      ...params,
      status: params.status as 'approved' | 'draft',
    });
    return {
      ...response,
      result: {
        items: response.result.amenities,
      },
    };
  },
  listAssociatedItems: async (pathParams, queryParams) => {
    const response = await AccommodationService.listPropertyAmenities(
      { roomId: pathParams.roomId },
      {
        ...queryParams,
        status: queryParams.status as 'approved' | 'draft',
      },
    );
    return {
      ...response,
      result: {
        items: response.result.amenities,
        total: response.result.total,
      },
    };
  },
  getAllAssociatedItemCodes: async (pathParams, queryParams) => {
    const response = await AccommodationService.listPropertyAmenities(
      { roomId: pathParams.roomId },
      {
        ...queryParams,
        status: queryParams.status as 'approved' | 'draft',
      },
    );
    return {
      ...response,
      result: {
        items: response.result.amenities,
      },
    };
  },
  addItem: async (pathParams, data) => {
    return await AccommodationService.addPropertyAmenity({ roomId: pathParams.roomId }, data);
  },
  updateItem: async (pathParams, data) => {
    return await AccommodationService.updatePropertyAmenity(
      { roomId: pathParams.roomId, amenityCode: pathParams.amenityCode },
      data,
    );
  },
  removeItem: async (pathParams) => {
    return await AccommodationService.removePropertyAmenity({
      roomId: pathParams.roomId,
      amenityCode: pathParams.amenityCode,
    });
  },

  // Query keys
  allItemsQueryKey: ['accommodation', 'amenities', 'all'],
  associatedItemsQueryKey: (roomId) => ['accommodation', 'room-amenities', roomId],
  allAssociatedCodesQueryKey: (roomId) => ['accommodation', 'room-amenities', roomId, 'all-codes'],

  // Labels
  itemName: 'Amenity',
  itemNamePlural: 'Amenities',
  associationContext: 'room',
};
